export class ParamsComposizioneLotto
{
  idLottoSpedizione: number;
  corriere: string;
  trackingId: string;
  idLottiAssegnati: number[];
  recVer: number;

  constructor() {
      this.idLottoSpedizione = null;
      this.corriere = null;
      this.trackingId = null;
      this.idLottiAssegnati = [];
      this.recVer = 0;
  }

}


// WEBPACK FOOTER //
// ./src/app/_models/params-composizione-lotto.ts